import {Injectable} from '@angular/core';
import {environment} from './../../../environments/environment';
import {Router} from '@angular/router';
import {JwtParserService} from './jwt-parser.service';
import {ParamService} from './param.service';
import {Location} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {v4 as uuidv4} from 'uuid';

@Injectable({
    providedIn: 'root',
})
export class AuthService {

    banner;
    isUserAuthenticated = false;
    checkUserHasActiveSession = false;
    populateSessionData$ = new BehaviorSubject(null);
    populateMobileSessionData$ = new BehaviorSubject(null);

    constructor(private router: Router,
                private location: Location,
                private jwtParserService: JwtParserService,
                private paramService: ParamService,
                private http: HttpClient) {
        this.banner = this.paramService.banner;
    }

    deleteCookie = (name, domain) => document.cookie = `${name}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/`;

    setCookie = (name, value) => document.cookie = `${name}=${value}; path=/`;

    isLocal() {
        if (window.location.href.indexOf('local') > 0) {
            return true;
        } else {
            return false;
        }
    }

    assignUrl(url) {
        window.location.assign(url);
    }

    async checkIfValidSWYUserInfo() {
        // clear any existing cookies
        this.clearEcomCookies();
        const windowUserInfo = window['AB']?.['userInfo'];
        if (this.validateWindowUserInfo(windowUserInfo) && !this.isLocal()) {
            this.checkTokenValidOrRedirectSSO(windowUserInfo);
            return this.isUserAuthenticated;
        }
        let url;
        if (this.isLocal()) {
            url = 'https://www-qa1.' + this.banner + '.com/bin/safeway/unified/userinfo?banner=' + this.banner;
        } else {
            url = 'https://' + window.location.host + '/bin/safeway/unified/userinfo?banner=' + this.banner;
        }
        await this.http.get(`${url}&rand=${uuidv4()}`, {withCredentials: true}).subscribe((response: any) => {
            this.checkTokenValidOrRedirectSSO(response);
            },
            error => {
                this.redirectToSSO(null);
            });

        return this.isUserAuthenticated;
    }

    checkTokenValidOrRedirectSSO(userInfo) {
        if (userInfo && userInfo['SWY_SHOP_TOKEN']) {
            if (userInfo.userType !== 'R') {
                this.checkTokenValid(userInfo);
            } else {
                localStorage.setItem('referralUrl', document.referrer);
                this.redirectToSSO(userInfo);
            }
        } else {
            localStorage.setItem('referralUrl', document.referrer);
            this.redirectToSSO(userInfo);
        }
    }

    async getUserLogedInToken() {
        // clear any existing cookies
        let url;
        const windowUserInfo = window['AB']?.['userInfo'];
        if (this.validateWindowUserInfo(windowUserInfo) && !this.isLocal()) {
            this.populateWindowUserInfoObject(windowUserInfo);
            return ;
        }
        if (this.isLocal()){
            url = 'https://www-qa1.' + this.banner + '.com/bin/safeway/unified/userinfo?banner=' + this.banner;
        } else {
            url = 'https://' + window.location.host + '/bin/safeway/unified/userinfo?banner=' + this.banner;
        }
        await this.http.get(`${url}&rand=${uuidv4()}`, {withCredentials: true}).subscribe((response: any) => {
                this.populateWindowUserInfoObject(response);
            },
            error => {
                this.populateSessionData$.next(null);
            });
    }

    populateWindowUserInfoObject(data) {
        let isUserAuthenticated;
        if (data && data['SWY_SHOP_TOKEN']) {
            isUserAuthenticated = this.checkUserTokenValidity(data);
        } else {
            isUserAuthenticated = false;
        }
        this.populateSessionData$.next({...(data), isTokenValid: isUserAuthenticated});
    }

    validateWindowUserInfo(userInfo) {
        if (userInfo && userInfo['SWY_SHOP_TOKEN']) {
            return true;
        }
        return false;
    }

    checkTokenValid(user) {
        const currentDate = new Date();
        const expiryDate = new Date(Number(user['expireTime']));
        if (user && user['SWY_SHOP_TOKEN'] && (expiryDate > currentDate)) {
            this.isUserAuthenticated = true;
            this.checkUserHasActiveSession = true;
        } else {
            this.isUserAuthenticated = false;
        }
    }

    checkUserTokenValidity(user) {
        let isTokenValid = false;
        const currentDate = new Date();
        const expiryDate = new Date(Number(user['expireTime']));
        if (user && user['SWY_SHOP_TOKEN'] && (expiryDate > currentDate)) {
            isTokenValid = true;
        }
        return isTokenValid;
    }

    isTokenValidForSession(user) {
        const currentDate = new Date();
        const expiryDate = new Date(Number(user['expireTime']));
        if (user && user['SWY_SHOP_TOKEN'] && (expiryDate > currentDate)) {
            this.isUserAuthenticated = true;
        } else {
            this.isUserAuthenticated = false;
        }
        return this.isUserAuthenticated;
    }

    isUserLoggedIn(user) {
        const currentDate = new Date();
        const expiryDate = new Date(Number(user['expireTime']));
        if (user && user['SWY_SHOP_TOKEN'] && (expiryDate > currentDate)) {
            this.isUserAuthenticated = true;
            this.checkUserHasActiveSession = true;
        } else {
            this.isUserAuthenticated = false;
        }
        return this.isUserAuthenticated;
    }

    redirectToSSO(user) {
        const sso_url = this.getSSORoute(user);
        this.setEcomRedirectURLCookie()
        this.assignUrl(sso_url);
    }

    getApplicationDomainURL() {
        let domain;
        if (this.isLocal()) {
            domain = 'https://www-qa1.' + this.banner + '.com';
        } else {
            domain = 'https://' + window.location.host;
        }
        return domain;
    }

    getB2BApplicationDomainURL() {
      let domain;
      if (this.isLocal()) {
          domain = 'https://business-qa1.' + this.banner + '.com';
      } else {
          domain = 'https://' + window.location.host;
      }
      return domain;
  }

    getSSORoute(user) {
        let sso_url;
        if (user && user['userType'] === 'G') {
            sso_url = this.getApplicationDomainURL() + environment.SIGN_IN_URL;
            sso_url = sso_url.replace(/\{banner\}/g, this.banner);
        } else if (user && user['userType'] === 'R') {
            sso_url = this.getApplicationDomainURL() + environment.RE_SIGN_IN_URL;
            sso_url = sso_url.replace(/\{banner\}/g, this.banner);
        } else {
            if (window['AB'] && window['AB']['COMMON'] && window['AB']['COMMON'].getCookie('SAFEWAY_KMSI') === true) {
                sso_url = this.getApplicationDomainURL() + environment.RE_SIGN_IN_URL;
                sso_url = sso_url.replace(/\{banner\}/g, this.banner);
            } else {
                sso_url = this.getApplicationDomainURL() + environment.SIGN_IN_URL;
                sso_url = sso_url.replace(/\{banner\}/g, this.banner);
            }
        }
        return sso_url;
    }

    redirectToHome() {
        const url = window['SWY'].CONFIGSERVICE.bannerDomainMap['www-' + this.banner];
        this.setEcomRedirectURLCookie()    
        this.assignUrl(url);
    }

    setEcomRedirectURLCookie() {
      let isB2B = this.checkB2B();
      let cookieURL;
      if (isB2B) {
        cookieURL = 'ACI_S_B_ECommRedirectURL';
      } else {
        cookieURL = 'ACI_S_ECommRedirectURL';
      }

      this.clearForceSignin();
      this.setCookie(cookieURL, encodeURIComponent(window.location.href));
    }

    public checkB2B() {
      const b2bEle = document.querySelector('#b2b');
      if (b2bEle && b2bEle.getAttribute('data-b2b').toLowerCase() === 'true') {
        return true
      }
      return false
    }

    clearEcomCookies() {
      let cookies = ['ACI_S_ECommRedirectURL', 'ACI_S_B_ECommRedirectURL']
      cookies.forEach(cookieURL => {
        this.deleteCookie(cookieURL, '');
      })
    }

    clearForceSignin() {
      const url = new URL(window.location.href);
      const params = url.searchParams;
    
      if (params.has('forceSignin') && params.get('forceSignin') === 'true') {
        params.delete('forceSignin');
        window.history.replaceState({}, '', url.toString());
      }
    }
}
